import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skada-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

}
